module.exports = __webpack_public_path__ + "img/cry.4c73e72c.svg";